import { useEffect, useId, useState } from 'react'

import { Input } from '../ui/input'

interface LoyaltyNumberFieldProps {
  label: string
  value: number
  onChange: (value: number) => void
  step?: string
  help?: string
  min?: number
  max?: number
  invalid?: boolean
  error?: string
  disabled?: boolean
}

function formatValue(value: number): string {
  return Number.isFinite(value) ? String(value) : ''
}

export function LoyaltyNumberField({
  label,
  value,
  onChange,
  step = '1',
  help,
  min = 0,
  max,
  invalid = false,
  error,
  disabled = false,
}: LoyaltyNumberFieldProps) {
  const inputId = useId()
  const helpId = `${inputId}-help`
  const errorId = `${inputId}-error`
  const describedBy = [help ? helpId : null, error ? errorId : null].filter(Boolean).join(' ') || undefined
  const [draftValue, setDraftValue] = useState(() => formatValue(value))

  useEffect(() => {
    setDraftValue(formatValue(value))
  }, [value])

  const selectZero = (input: HTMLInputElement) => {
    if (input.value === '0') {
      input.select()
    }
  }

  return (
    <div className="space-y-2">
      <label htmlFor={inputId} className="text-sm font-medium text-slate-700">
        {label}:
      </label>
      <Input
        id={inputId}
        type="number"
        min={min}
        max={max}
        step={step}
        value={draftValue}
        aria-invalid={invalid}
        aria-describedby={describedBy}
        disabled={disabled}
        onFocus={(event) => selectZero(event.currentTarget)}
        onClick={(event) => selectZero(event.currentTarget)}
        onChange={(event) => {
          const nextValue = event.target.value
          setDraftValue(nextValue)

          if (nextValue !== '') {
            onChange(Number(nextValue))
          }
        }}
        onBlur={(event) => {
          if (event.currentTarget.value === '') {
            setDraftValue(formatValue(value))
          }
        }}
      />
      {help && <p id={helpId} className="text-xs text-slate-500">{help}</p>}
      {error && <p id={errorId} role="alert" className="text-xs text-red-600">{error}</p>}
    </div>
  )
}
